import React from 'react';
import { Box, Typography } from '@mui/material';
import ActionDialog from 'common/components/ActionDialog';
import { useTranslation } from 'services/localization/useTranslation';

interface Props {
	rowIds: string[];
	onClose: () => void;
	deleteRows: (ids: string[]) => void;
}

const VariantDeleteRowsDialog = (props: Props) => {
	const { t } = useTranslation();

	const handleDelete = () => {
		props.deleteRows(props.rowIds);
		props.onClose();
	};

	return (
		<ActionDialog
			title={t('product.variantsTable.rowsDeleteTitle', 'Delete rows?')}
			headerVariant="contained"
			btnActions={{
				primary: {
					text: t('common:actions.delete'),
					onClick: handleDelete,
				},
				secondary: {
					text: t('common:actions.cancel'),
					onClick: props.onClose,
				},
			}}
			onClose={props.onClose}
			variant="danger"
		>
			<Box mt={1}>
				<Typography variant="body1">
					{t('product.variantsTable.rowsDeleteBody1', {
						rowCount: props.rowIds.length,
						defaultValue: 'Are you sure you want to delete selected {{rowCount}} rows',
					})}
				</Typography>
			</Box>
			<Box mt={1}>
				<Typography variant="body1">
					{t('product.variantsTable.rowsDeleteBody2', 'This action cannot be undone.')}
				</Typography>
			</Box>
		</ActionDialog>
	);
};

export default VariantDeleteRowsDialog;
